// @dynamic-i18n-keys
//   daProtect.tooltip.var.active
//   daProtect.tooltip.var.inactive
//   daProtect.tooltip.var.temporary
//   daProtect.label.mobile.var.active
//   daProtect.label.mobile.var.inactive
//   daProtect.label.mobile.var.temporary
//   daProtect.label.desktop.var.active
//   daProtect.label.desktop.var.inactive
//   daProtect.label.desktop.var.temporary
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import DAProtect, { Props as DAProtectProps } from '@wix/da-ds/pkg/Indicators/DAProtect';
import SophisticatedTooltipLink from '@wix/da-ds/pkg/tooltips/SophisticatedTooltipLink';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { URLS } from '@wix/da-url';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';
import { BiData, BuyCoreButtonBiEvent } from '@wix/da-bi/pkg/events';

import s from './DAProtectIconWithTooltip.scss';

export interface Props extends DAProtectProps {
  withLabel?: boolean;
}

const DAProtectIconWithTooltip: React.FC<Props> = ({ variant, withLabel = false, ...rest }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);

  return (
    <SophisticatedTooltip
      size="medium"
      aria-label={t(`daProtect.tooltip.ariaLabel`)}
      description={t(`daProtect.tooltip.var.${variant}`)}
      hasCloseButton={false}
      postfix={
        variant === 'active' ? (
          <SophisticatedTooltipLink href="https://www.deviantartsupport.com/en/article/what-is-deviantart-protect">
            {t('daProtect.tooltip.learnMore')}
          </SophisticatedTooltipLink>
        ) : (
          <SophisticatedTooltipLink
            href={URLS.CORE_MEMBERSHIP}
            biData={BiData<BuyCoreButtonBiEvent>({
              evid: 375,
              referral_info:
                variant === 'inactive' ? ReferralType.DAPROTECT_OFF : ReferralType.DAPROTECT_TEMP,
            })}
          >
            {t('daProtect.tooltip.upgrade')}
          </SophisticatedTooltipLink>
        )
      }
    >
      <div className={s['icon']}>
        <DAProtect variant={variant} {...rest} />
        {withLabel && (
          <span className={s['label']}>
            {isMobile && t(`daProtect.label.mobile.var.${variant}`)}
            {!isMobile && t(`daProtect.label.desktop.var.${variant}`)}
          </span>
        )}
      </div>
    </SophisticatedTooltip>
  );
};
DAProtectIconWithTooltip.displayName = 'DAProtectIconWithTooltip';

export default DAProtectIconWithTooltip;
